import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  AUDIO_SUB_TYPES,
  planTypes,
} from '@/common/constants';

export default {
  created() {
    this.watchUnlimitedAudioLicenseChange(this.unlimitedAudioLicense, this.oldUnlimitedAudioLicense)
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'boughtPlans', 'unlimitedAudioLicense']),
    oldUnlimitedAudioLicense() {
      return this.audioUnlimitedPlan?.cartInfo.selected_number || 0;
    },
    audioUnlimitedPlan() {
      return this.boughtPlans.find(item => (
        item.type === planTypes.TOLLFREE &&
        item.category === AUDIO_SUB_TYPES.UNLIMITED
      ));
    },
  },

  beforeUnmount() {
    // The beforeUnmount hook is triggered indicating that the associated plan has been removed
    // Forced to execute once to make sure the audio unlimited plan should also be removed
    this.watchUnlimitedAudioLicenseChange(this.unlimitedAudioLicense, this.oldUnlimitedAudioLicense, true);
  },

  methods: {
    ...mapActions({
      removePlanAction: 'removePlanAction',
    }),
    ...mapMutations(['updateSelectPlan', 'setPreventAutoCollapseOnce']),
    watchUnlimitedAudioLicenseChange(newLicense, oldLicense, forceExec = false) {
      if (!forceExec && newLicense === oldLicense) return;
      if(!this.audioUnlimitedPlan) return;
      function __updateShoppingCart() {
        if(newLicense === this.oldUnlimitedAudioLicense) {
          this.removePlanAction(this.audioUnlimitedPlan.plan_code);
          // Need mixin planMixin
          this.removePlanByKey && this.removePlanByKey(planTypes[planTypes.TOLLFREE]);
          return;
        };
        this.updateSelectPlan({
          ...this.audioUnlimitedPlan,
          planType: planTypes.TOLLFREE,
          cartInfo: {
            selected_number: this.unlimitedAudioLicense,
          },
        });
        this.setPreventAutoCollapseOnce(true);
        this.$emit('add', planTypes[planTypes.TOLLFREE])
      }
      if (forceExec) {
        __updateShoppingCart.call(this);
      } else {
        // Exec in next tick.
        this.$nextTick(__updateShoppingCart.bind(this));
      }
    },
  },
  watch: {
    unlimitedAudioLicense(value, oldValue) {
      this.watchUnlimitedAudioLicenseChange(value, oldValue);
    },
  },
}
